import { Column } from 'src/components/table/CustomTable.interface';
import { lang } from 'src/utils';

export const getLocationColumns = (): Column[] => [
  { id: 'name', label: lang.locations },
  { id: 'store_number', label: lang.storeNo },
  { id: 'tags', label: lang.tags },
  { id: 'banner', label: lang.banner, width: '120px', align: 'left' },
  { id: 'messaging', label: lang.messaging, width: '120px', align: 'left' },
];
